<template>
    <b-row>
        <div class="title mt-3">
            {{ title }}
        </div>
        <div class="contentContainer mt-4">
            <div class="content">
                <p>ISIN : {{ isin }}</p>
            </div>
            <div class="content">
                <p>Secteur : {{ secteur }}</p>
            </div>
        </div>
    </b-row>
</template>
<script>
export default {
    props: ["title", "amf", "indice", "secteur", "isin"]
};
</script>
<style lang="scss"></style>
